<template>
  <div  v-loading="loading"
       class="dashboard-area">
    <div class="dashboard-area--title flex justify-between">
      <div class="flex align-center">
        <span>销售报告</span>
        <gj-help style="margin-left: 10px;">
          <div>数据来源：亚马逊销售订单；</div>
          <div>使用说明：默认以所有店铺站点当前市场时间进行计算，比实时看板数据延迟30分钟，除已取消订单不计入，其他所有状态参与计算，将导致销售相关字段数据虚高。</div>
        </gj-help>
        <i @click="$gjQuery" class="iconfont iconshuaxin"></i>
        <span class="color666 size12">数据更新时间：{{updateTime}}</span>
      </div>


<!--      <span v-if="date" class="panel-time">-->
<!--        {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}-->
<!--      </span>-->
      <div class="dashboard-area--rt-link">
        <gj-link :route-to="moreLink" class="color666">查看更多 ></gj-link>
      </div>
    </div>

    <div class="flex">
      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          :title="'销售额'+(data.currencySymbol?`(${data.currencySymbol})`:'')"
          :number="amountSymbol(data.sales)"
          :compareNumber="amountSymbol(data.sales-data.ringSales)"
          width="20%"
          @click="selectChart('sales', '销售额')"
          :active="type === 'sales'"
          :isNumberColumn="clientWidth <= 1600"
          hasTip
      >
        <template #hasTip>
          已支付销售额：{{data.paySales | defaultShow(data.currencySymbol)}}<br>
          将支付销售额：{{data.noPaySales | defaultShow(data.currencySymbol)}}<br>
          总销售额：{{data.sales | defaultShow(data.currencySymbol)}}
        </template>
      </gj-card>
      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          title="销量"
          :number="defaultShow(data.saleQuantity)"
          :compareNumber="defaultShow(data.saleQuantity-data.ringSaleQuantity)"
          width="20%"
          @click="selectChart('saleQuantity', '销量')"
          :active="type === 'saleQuantity'"
          :isNumberColumn="clientWidth <= 1600"
          hasTip
      >
        <template #hasTip>
          已支付销量：{{data.paySaleQuantity | defaultShow}}<br>
          将支付销量：{{data.noPaySaleQuantity | defaultShow}}<br>
          总销量：{{data.saleQuantity | defaultShow}}
        </template>
      </gj-card>
      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          title="订单量"
          :number="defaultShow(data.orderQuantity)"
          :compareNumber="defaultShow(data.orderQuantity-data.ringOrderQuantity)"
          width="20%"
          @click="selectChart('orderQuantity', '订单量')"
          :active="type === 'orderQuantity'"
          :isNumberColumn="clientWidth <= 1600"
          hasTip
      >
        <template #hasTip>
          已支付订单量：{{data.payOrderQuantity | defaultShow}}<br>
          将支付订单量：{{data.noPayOrderQuantity | defaultShow}}<br>
          总订单量：{{data.orderQuantity | defaultShow}}
        </template>
      </gj-card>
      <gj-card
          height="100px"
          padding="19px 0 19px 16px"
          tabCard
          :title="'平均单价'+(data.currencySymbol?`(${data.currencySymbol})`:'')"
          :number="defaultShow(data.customerPrice)"
          :compareNumber="defaultShow((data.customerPrice-data.ringCustomerPrice).toFixed(2))"
          width="20%"
          @click="selectChart('customerPrice', '平均单价')"
          :active="type === 'customerPrice'"
          :isNumberColumn="clientWidth <= 1600"
      >
      </gj-card>
      <gj-card
          height="100px"
          tabCard
          padding="19px 0 19px 16px"
          title="退款量"
          :number="defaultShow(data.refundQuantity)"
          :compareNumber="defaultShow(data.refundQuantity-data.ringRefundQuantity)"
          width="20%"
          @click="selectChart('refundQuantity', '退款量')"
          :active="type === 'refundQuantity'"
          :isNumberColumn="clientWidth <= 1600"
      >
      </gj-card>
    </div>

<!--    <el-row :gutter="10">-->

<!--      <el-col class="total-panel&#45;&#45;5">-->
<!--        <div class="total-panel&#45;&#45;report"-->
<!--             :class="{'active': type === 'sales'}"-->
<!--             @click="selectChart('sales', '销售额')">-->
<!--          <div class="total-panel&#45;&#45;title">销售额{{data.currencySymbol | defaultShow('(', ')', '')}}</div>-->
<!--          <div class="total-panel&#45;&#45;summary">{{data.sales | defaultShow}}</div>-->
<!--        </div>-->
<!--      </el-col>-->

<!--      <el-col class="total-panel&#45;&#45;5">-->
<!--        <div class="total-panel&#45;&#45;report"-->
<!--             :class="{'active': type === 'saleQuantity'}"-->
<!--             @click="selectChart('saleQuantity', '销量')">-->
<!--          <div class="total-panel&#45;&#45;title">销量</div>-->
<!--          <div class="total-panel&#45;&#45;summary">{{data.saleQuantity | defaultShow}}</div>-->
<!--        </div>-->
<!--      </el-col>-->

<!--      <el-col class="total-panel&#45;&#45;5">-->
<!--        <div class="total-panel&#45;&#45;report"-->
<!--             :class="{'active': type === 'orderQuantity'}"-->
<!--             @click="selectChart('orderQuantity', '订单量')">-->
<!--          <div class="total-panel&#45;&#45;title">订单量</div>-->
<!--          <div class="total-panel&#45;&#45;summary">{{data.orderQuantity | defaultShow}}</div>-->
<!--        </div>-->
<!--      </el-col>-->

<!--      <el-col class="total-panel&#45;&#45;5">-->
<!--        <div class="total-panel&#45;&#45;report"-->
<!--             :class="{'active': type === 'customerPrice'}"-->
<!--             @click="selectChart('customerPrice', '平均单价')">-->
<!--          <div class="total-panel&#45;&#45;title">平均单价{{data.currencySymbol | defaultShow('(', ')', '')}}</div>-->
<!--          <div class="total-panel&#45;&#45;summary">{{data.customerPrice | defaultShow}}</div>-->
<!--        </div>-->
<!--      </el-col>-->

<!--      <el-col class="total-panel&#45;&#45;5">-->
<!--        <div class="total-panel&#45;&#45;report"-->
<!--             :class="{'active': type === 'refundQuantity'}"-->
<!--             @click="selectChart('refundQuantity', '退款量')">-->
<!--          <div class="total-panel&#45;&#45;title">退款量</div>-->
<!--          <div class="total-panel&#45;&#45;summary">{{data.refundQuantity | defaultShow}}</div>-->
<!--        </div>-->
<!--      </el-col>-->

<!--    </el-row>-->
    <div ref="chart" class="report-chart"></div>
  </div>
</template>

<script>
  import {getSaleReport} from "../../../../../api/dashboard";
  import {countryMarketParams, isMeaningful, isMeaningless} from "../../../../../utils/common";
  import {convertToDate, convertToFullDate, dateShortcut} from "../../../../../utils/date.util";
  import {amountSymbol,defaultShow} from "@/filters";
  import {dashboardMixin, queryMixin} from "@/minxins";
  import {mapGetters} from "vuex";

  export default {
    name: "app-dashboard-sale-report",
    mixins: [queryMixin, dashboardMixin],
    props: {
      date: {
        required: true
      },
      dateType: null,// 日期类型，自定义时间传''，近7天seven/近14天fourteen/近30天thirty/本周week/本月month
    },
    data() {
      return {
        loading: false,
        chart: null,
        type: '',
        data: {},
        updateTime:convertToFullDate(new Date(),"yyyy-MM-dd hh:mm:ss"),
        activeType:'saleQuantity',
        activeName:'销量',
      }
    },
    computed: {
      startDate() {
        if(this.dateType===''){
          return this.date ? convertToDate(this.date[0]) : '';
        }else {
          return this.data.charData? this.data.charData[0].statisticsDate : '';
        }

      },
      endDate() {
        if(this.dateType===''){
          return this.date ? convertToDate(this.date[1]) : '';
        }else {
          return this.data.charData? this.data.charData[this.data.charData.length-1].statisticsDate : '';
        }

      },
      dateShortcut() {
        return dateShortcut(this.date);
      },
      moreLink() {
        return `/statistics/listing-statistics?startDate=${this.startDate}&endDate=${this.endDate}`
      }
    },
    mounted() {
      this.renderChart();
    },
    methods: {
      defaultShow,
      amountSymbol,
      $gjQuery(){
        if(!this.showStoreMask){
          return
        }
        // 缓存了时区时，第一次不请求
        if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
          return
        }
        this.loading = true;
        // 构造查询参数
        const params = {
          currency: this.dashboardCurrency,// 币种
          dateType: this.dateType, // 日期类型，自定义时间传''，近7天seven/近14天fourteen/近30天thirty/本周week/本月month
          dateTime: this.timezoneText,// 站点时间
          startDate: this.startDate,
          endDate: this.endDate,
          ...countryMarketParams(this.countryMarket),
        };
        getSaleReport(params)
            .then((data) => {
              this.data = data;
              this.updateTime = convertToFullDate(new Date(),"yyyy-MM-dd hh:mm:ss")
              this.selectChart(this.activeType, this.activeName);
            })
            .complete(() => this.loading = false);
      },
      selectChart(type, typeName) {
        this.activeType = type;
        this.activeName = typeName;
        if (isMeaningless(this.data)) {
          return;
        }
        this.type = type;
        const showCurrencySymbol = ['销售额', '平均单价'].includes(typeName);
        this.chart.setOption({
          legend: {
            data: [typeName, `同期${typeName}`],
          },
          xAxis: {
            data: this.data.charData.map(item => item.showDate),
          },
          series: [
            {
              name: typeName,
              type: 'line',
              showSymbol: false,
              symbol:'circle',
              data: this.data.charData.map(item => ({
                value: item[type] || 0,
                statisticsDate: item.statisticsDate,
                prefix: showCurrencySymbol ? item.currencySymbol : '',
                suffix: '',
                data: item
              }))
            },
            {
              name: `同期${typeName}`,
              type: 'line',
              showSymbol: false,
              symbol:'circle',
              data: this.data.periodCharData.map(item => ({
                value: item[type] || 0,
                statisticsDate: item.statisticsDate,
                prefix: showCurrencySymbol ? item.currencySymbol : '',
                suffix: '',
                data: item
              }))
            }
          ]
        });
      },
      renderChart() {
        const chartRef = this.$refs.chart;
        if (chartRef) {
          this.chart = this.$echarts.init(chartRef);
          const option = {
            color: ["#409EFF", "#67C23A"],
            tooltip: {
              trigger: 'axis',
              axisPointer:{
                z:0
              },
              formatter: function(e) {

                // 基础数据
                const data = [];
                const periodData = [];
                e.forEach(item => {
                  if (item.seriesName.includes('同期')) {
                    if (periodData.length === 0) {
                      periodData.push(`${item.data.statisticsDate}`);
                    }
                    periodData.push(`${item.seriesName}：${item.data.prefix}${item.data.value}${item.data.suffix}`);
                  } else {
                    if (data.length === 0) {
                      data.push(`${item.data.statisticsDate}`);
                    }
                    data.push(`${item.seriesName}：${item.data.prefix}${item.data.value}${item.data.suffix}`);
                  }
                });
                // 分割线
                let divider = '';
                if (data.length > 0 && periodData.length > 0) {
                  divider = '<div style="background: #999; height: 2px; margin: 6px 0;"></div>';
                }
                return `<div style="min-width: 180px;">${data.join('<br/>')}${divider}${periodData.join('<br/>')}</div>`;
              },
              position: function(point, params, dom, rect, size) {
                if (point[0] + size.contentSize[0] + 30 > size.viewSize[0]) {
                  return [point[0] - size.contentSize[0] - 30, '15%'];
                }
                return [point[0] + 20, '15%'];
              },
            },
            legend: {
              itemGap: 50,
              icon: "rect",
              itemWidth: 15,
              itemHeight: 3,
              data: [],
              textStyle: {
                color: '#888',
                padding: [2, 0, 0, 0],
              }
            },
            grid: {
              top: 32,
              left: '2%',
              right: '2%',
              bottom: '0%',
              containLabel: true
            },
            xAxis: {
              axisLabel: {
                color: "#32393d"
              },
              axisLine: {
                lineStyle: {
                  color: "#32393d"
                }
              },
              data: [],
            },
            yAxis: {
              name: "",
              position: "left",
              axisLabel: {
                margin: 4,
                formatter: function (e) {
                  var t = Math.abs(e);
                  return t >= 1e4 && t < 1e7 ?
                    t = t / 1e4 + "万" :
                    t >= 1e7 && (t = t / 1e7 + "千万"), t;
                },
                color: "#32393d"
              },
              splitLine: {
                lineStyle: {
                  color: "#e5e9f2"
                }
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: "#FFF"
                }
              }
            },
            series: []
          };
          this.chart.setOption(option);
          // 联动配置
          this.chart.group = 'dashboardReportGroup';
          this.$echarts.connect('dashboardReportGroup');
          window.addEventListener("resize", () => {
            this.chart.resize();
          });
          this.$on('hook:destroyed', () => {
            window.removeEventListener("resize", function () {});
            this.$echarts.disconnect('dashboardReportGroup');
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../common";
  .gj-card{
    // border-right: 0;
  }
  .gj-card:first-child{
    border-radius: 2px 0 0 2px;
  }
  .gj-card:last-child{
    border-right: 1px solid #D8DADD;
    border-radius: 0 2px 2px 0;
  }
  .dashboard-area{
    padding-top: 0;
    padding-right: 11px;
  }
  .dashboard-area--title{
    font-size: 14px;
    font-weight: 400;
  }
</style>
